(function() { window.GUID_27f57a7d_fcc0_4627_9b9c_bd58d95ada89 = { getGuid: function() { return "27f57a7d-fcc0-4627-9b9c-bd58d95ada89"; } }; })();
var Newsfeed;
(function (Newsfeed) {
    let Filter;
    (function (Filter) {
        Filter[Filter["All"] = 0] = "All";
        Filter[Filter["FromMe"] = 1] = "FromMe";
        Filter[Filter["ToMe"] = 2] = "ToMe";
    })(Filter = Newsfeed.Filter || (Newsfeed.Filter = {}));
    new Newsfeed.NewsfeedPosts();
})(Newsfeed || (Newsfeed = {}));

//# sourceMappingURL=newsfeed.js.map
